export { default } from "./MacWindow";
